import Controller from './controller'
import dataLayer from '../helpers/datalayer'

export default class extends Controller {
  static get targets() {
    return ['nursery']
  }

  initialize() {
    this.go = this.go.bind(this)
  }

  connect() {
    const eventBookAVisit = this.eventBookAVisit.bind(this)
    const eventWaitingList = this.eventWaitingList.bind(this)
    const body = document.querySelector('body')
    if (!body.classList.contains('freeform-ajax-success')) {
      body.classList.add('freeform-ajax-success')
      document.addEventListener('freeform-before-ajax-success', (event) => {
        const form = event.form;
        const response = event.response;

        if (response.success && response.finished) {
          if (['booking','waitingList'].includes(form.dataset.handle)) {
            const nursery = form.querySelector('[data-datalayer-target="nursery"]')?.value
            if (form.dataset.handle == "booking") eventBookAVisit(nursery, response);
            if (form.dataset.handle == "waitingList") eventWaitingList(nursery);
          }
        }
      })
    }
  }

  get nursery() {
    if (!this.hasNurseryTarget) return

    return this.nurseryTarget.value
  }

  go(event) {
    // console.log(event.currentTarget.getAttribute('data-datalayer-event'))
    dataLayer({
      event: event.currentTarget.getAttribute('data-datalayer-event'),
      nursery: null,
    })
  }

  gtmLoaded() {
    return !!window['google_tag_data']
  }

  shouldProceed(id) {
    return id === undefined || id.split('-')[0] == 'G'
  }

  eventEmailClick(event) {
    if (!this.gtmLoaded()) {
      return true
    }

    event.preventDefault()
    dataLayer({
      event: 'email_click',
      nursery: null,
      eventCallback: (id) => {
        if (this.shouldProceed(id)) {
          window.location = event.target.href
        }
      },
      eventTimeout: 2000,
    })
  }

  eventPhoneClick(event) {
    if (!this.gtmLoaded()) {
      return true
    }

    event.preventDefault()
    dataLayer({
      event: 'phone_click',
      nursery: null,
      eventCallback: (id) => {
        if (this.shouldProceed(id)) {
          window.location = event.target.href
        }
      },
      eventTimeout: 2000,
    })
  }

  eventBookAVisit(passNursery, response) {
    if (!this.gtmLoaded()) {
      return true
    }

    const nursery = passNursery || this.nursery
    const phone = [
      response.values.diallingCode,
      response.values.phoneNumber.toString().replace(/^0/, '')
    ].join('')

    const nameParts = response.values.name.split(' ')
    const lastName = nameParts.pop()
    const firstName = nameParts.join(' ')

    dataLayer({
      event: 'book_a_visit',
      nursery,
      user_data: {
        email_address: response.values.email,
        phone_number: phone,
        address: {
          first_name: firstName,
          last_name: lastName,
        },
      },
    })
  }

  eventWaitingList(passNursery) {
    if (!this.gtmLoaded()) {
      return true
    }

    const nursery = passNursery || this.nursery

    dataLayer({
      event: 'waiting_list',
      nursery,
    })
  }

  eventMakeAPayment() {
    dataLayer({
      event: 'make_a_payment',
      nursery: null,
    })
  }

  eventFeeDownload(event) {
    if (!this.gtmLoaded()) {
      return true
    }

    event.preventDefault()
    dataLayer({
      event: 'fee_download',
      nursery: null,
      eventCallback: (id) => {
        if (this.shouldProceed(id)) {
          window.location = event.target.href
        }
      },
      eventTimeout: 2000,
    })
  }
}
